// Legacy export format because this is used by some build-time scripts stuck in the past.
// eslint-disable-next-line import/no-commonjs
module.exports = {
    APP_NAME: 'PotentiaMod',
    API_HOST: 'https://potentiamod.github.io/potentiamax',
    MOTTO: 'TurboWarp, Supercharged',
    SLOGAN: 'It Makes the Very Best',
    LINK: 'https://potentiamod.github.io',
    HOME_LINK: 'https://potentiamod.github.io/home',
    LIBRARY_SITE: 'https://potentiamod.github.io/scratch-library/',
    CLOUD_HOST: 'wss://clouddata.turbowarp.org',
    enableGenerate: false
};
